import { Field } from 'Util/Query';

/** @namespace Bodymod/PostNord/Query/PostNord/Query */
export class PostNordQuery {
    resultField() {
        return new Field('result');
    }

    pickupPointsField() {
        return new Field('pickupPoints');
    }

    getPostNordMutation(input) {
        const mutation = new Field('postNordSave')
            .addArgument('input', 'PostNordPickupPointArugments!', input)
            .addField(this.resultField());

        return mutation;
    }

    getPostNordPoints(input) {
        return new Field('postNordGet')
            .addArgument('input', 'PostNordAddressDetails!', input)
            .addField(this.pickupPointsField());
    }
}

export default new PostNordQuery();
